import './shared/types';

/**
 * @typedef {object} MatchCentreState
 * @property {PlayerStatsState} playerStats
 */

/**
 * @typedef {object} PlayerStatsState
 * @property {PlayerStatsNavState} nav
 * @property {StatsSortState} sort
 * @property {PlayerStatsDataTypeState} dataType
 * @property {PlayerStatsCustomFieldsState} customFields
 * @property {PlayerStatsTempraryFieldsState} temporaryFields
 * @property {PlayerStatsModalState} modal
 */

/**
 * @typedef {object} PlayerStatsNavState
 * @property {string} stats
 * @property {string} teams
 */

/**
 * @typedef {object} PlayerStatsDataTypeState
 * @property {'totals'|'averages'|'benchmarkedTotals'|'benchmarkedAverages'} dataType.type
 */

/**
 * @typedef {any} PlayerStatsCustomFieldsState
 */

/**
 * @typedef {any} PlayerStatsTempraryFieldsState
 */

/**
 * @typedef {object} PlayerStatsModalState
 * @property {boolean} isOpen
 */
